import React from "react";
import "./loader.scss";

const Loader = () => {
  return (
    <div className="pt-2">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
